import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GroupType, ProcessedValuePredictorAnswer, UnprocessedValuePredictorAnswer } from '@fgb/core';

@Component({
  selector: 'fgbcl-answer-multi-counter',
  templateUrl: './answer-multi-counter.component.html',
  styleUrl: './answer-multi-counter.component.scss',
})
export class AnswerMultiCounterComponent {
  @Input() answers: UnprocessedValuePredictorAnswer[] | ProcessedValuePredictorAnswer[] = [];
  @Input() groupType: GroupType;
  groupTypes = GroupType;
  @Output() answerSelected = new EventEmitter<any>();
  @Input() isExternal: boolean = false;

  onAnswerSelected(answerId: number, answer: any) {
    if (this.groupType == GroupType.Predictor) {
      this.answerSelected.emit({ answerId: answerId, customerValue: answer });
    }
  }
}
